import { render, staticRenderFns } from "./PartnerModalForm.vue?vue&type=template&id=10940946"
import script from "./PartnerModalForm.vue?vue&type=script&lang=js"
export * from "./PartnerModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports